import * as React from "react";

const PlayIconJSX = props => (
  <svg xmlns="http://www.w3.org/2000/svg" width={12} height={14} fill="none" {...props}>
    <path
      fill="#3B82F6"
      d="M11 7a.983.983 0 0 1-.475.845L1.52 13.353A1 1 0 0 1 0 12.508V1.492A.991.991 0 0 1 .507.628a1 1 0 0 1 1.013.02l9.005 5.508A.983.983 0 0 1 11 7Z"
    />
  </svg>
);
export default PlayIconJSX;
